import { Component, EventEmitter, Inject, Input, OnDestroy, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { CircularGaugeComponent, Gradient, Legend, GaugeTooltip, RangeModel } from '@syncfusion/ej2-angular-circulargauge';
import { interval, range, Subject, Subscription, takeUntil } from 'rxjs';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';
import { DOCUMENT } from '@angular/common';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';

@Component({
	selector: 'app-dashboard-annotated-gauge',
	templateUrl: './dashboard-annotated-gauge.component.html',
	styleUrls: ['./dashboard-annotated-gauge.component.scss']
})
export class DashboardAnnotatedGaugeComponent implements OnDestroy {

	Math = Math;

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** panelData */
	@Input() panelData: any;

	/** publicPanelData */
	@Input() publicPanelData: PanelData[];

	/** refresh */
	@Input() refresh: boolean;

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** isMobile */
	@Input() isMobile: boolean;

	/** gauge */
	@ViewChild('gauge') gauge!: CircularGaugeComponent;

	/** gauges */
	@ViewChildren('gauge') gauges!: QueryList<CircularGaugeComponent>;

	/** panel */
	@ViewChild('panel') panel!: any;

	/** intervalFinish */
	@Output() intervalFinish = new EventEmitter<any>();

	/** borderChange */
	@Output() borderChange = new EventEmitter<string>();

	/** editComponent */
	@Output() editComponent = new EventEmitter<any>();

	/** Page Refresh Interval object */
	private refreshInterval: Subscription | null;

	/** refreshTime */
	private refreshTime: number = 0.5;

	/** axisConfig */
	public axisConfig: { min: number, max: number, interval: number }[] = [];

	/** localPanelData */
	public localPanelData: PanelData[] = [];

	/** labelStyle */
	public labelStyle: any = {
		offset: -10,
		position: "Outside"
	}

	/** legendSettings */
	public legendSettings: Object = {
		visible: false,
		position: 'Bottom'
	};

	/** narrowPanel */
	public narrowPanel: boolean = false;

	/** gaugeRanges */
	public gaugeRanges: { start: number, end: number }[] = [
		{ start: 0, end: 30 },
		{ start: 30, end: 70 },
		{ start: 70, end: 100 }
	];

	/** isNewGauge */
	public isNewGauge: boolean = true;

	public titleStyle: Object = { fontFamily: 'inherit' };
	public title: string = 'Progress Tracker';

	public lineStyle: Object = {
		width: 0
	};

	public labelStyleNew: Object = {
		position: 'Cross', useRangeColor: false,
		font: { size: '10px', fontFamily: 'inherit' }
	};

	/** rangeWidth */
	public rangeWidth: number = 15;

	public ranges: Object[] = [
		{
			start: 0, end: 100,
			radius: '90%',
			startWidth: this.rangeWidth, endWidth: this.rangeWidth,
			color: '#E0E0E0',
			roundedCornerRadius: 20
		},
	];

	public pointers: Object[] = [{
		roundedCornerRadius: 20,
		value: 10,
		type: 'RangeBar',
		radius: '90%',
		color: '#e5ce20',
		border: {
			width: 0
		},
		animation: {
			enable: false
		},
		pointerWidth: 30
	}];

	public majorTicks: any[] = [
		{
			height: 0,
			width: 0
		},
		{
			height: 0,
			width: 0
		}
	];

	public minorTicks: Object = {
		height: 0
	};

	public annotations: Object = [{
		description: 'RangeBar pointer value from the slider',
		content: '<div id="pointervalue" style="font-size:35px;width:120px;text-align:center;">' +
			'30</div>',
		angle: 0,
		zIndex: '1',
		radius: '0%'
	}];

	/** defaultRangeColours */
	public defaultRangeColours: string[] = ["green", "orange", "red"];

	/** isPointerType */
	public isPointerType: boolean = false;

	/** currentBorderColour */
	public currentBorderColour: string = "";

	/** indexColours */
	public indexColours: { colour: string, score: number, border: boolean }[] = [];

	/** borderScore */
	public borderScore: number = 0;

	/** tooltip */
	public tooltip: Object = {
		enable: true,
		type: ['Range'],
		rangeSettings: {
			showAtMousePosition: true,
			// format: "Start Value: {start} <br> End Value: {end}",
			textStyle: {
				size: '13px',
				fontFamily: 'inherit'
			}
		}
	};

	/** testingValue */
	@Input() public testingValue: number = 10;

	/** inactiveRangeOpacity */
	public inactiveRangeOpacity: number = 0.25;

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions  
	 * @param siteSubscriptions siteSubscriptions 
	 * @param document document 
	 * @param vcr vcr 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef
	) {
		/** Get required subscriptions */
		// combineLatest([
		// 	this.siteSubscriptions.selectedOrganisation$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
		// ]).pipe(
		// 	// Ensure that subscriptions are not null or undefined
		// 	filter(([selectedAccount]) => !!selectedAccount)
		// ).subscribe({
		// 	next: ([selectedAccount]) => {
		// 	},
		// 	error: (error) => {
		// 		this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
		// 	}
		// });
	}

	/**
	 * ngAfterViewInit
	 */
	ngAfterViewInit(): void {
		// if (!this.creating) {
		this.getPanelWidth();
		// }
	}

	/**
	 * getPanelWidth
	 */
	getPanelWidth() {
		if (this.panel) {
			if (!this.creating) {
				this.setMinMaxInterval();
				this.setGaugeRanges();
			}
			setTimeout(() => {
				if (this.panel.nativeElement.offsetWidth <= 350) {
					// this.narrowPanel = true;
					// setTimeout(() => {
					// 	this.respondToRefreshOLD();
					// }, 0);
				}
			}, 0);
		} else {
			setTimeout(() => {
				this.getPanelWidth();
			}, 100);
		}
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		this.refreshInterval = interval((this.refreshTime * 60000)).pipe(takeUntil(this.finalise)).subscribe(() => {
			this.intervalFinish.emit(this.panelData);
		});
		// this.setUpObserver();
	}

	/**
	 * setUpObserver
	 */
	setUpObserver() {
		if (this.gauges.length > 0) {
			const observer = new ResizeObserver(entries => {
				if (this.gauges.length > 0) {
					for (const entry of entries) {
						const height: number = entry.contentRect.height ?? 0;
						const width: number = entry.contentRect.width ?? 0;

						const title: HTMLElement | null = <HTMLElement>entry.target.getElementsByClassName("text-panel-title")[0];

						this.gauges.forEach((gauge: CircularGaugeComponent) => {
							gauge.height = `${(!title ? height : height - title.offsetHeight) * 1}px`;
							gauge.width = `${width}px`;
							// gauge.refresh();
						});
					}
				}
			});
			let parent: HTMLElement | null = this.gauge.element;
			let panel: HTMLElement | undefined = undefined;
			while (parent) {
				if (parent.classList.contains("panel-host")) {
					panel = parent;
					parent = null;
					break;
				} else {
					parent = parent.parentElement;
				}
			}
			if (panel) {
				observer.observe(panel);
			}
		} else {
			setTimeout(() => {
				this.setUpObserver();
			}, 100);
		}
	}

	/**
	 * ngOnChanges
	 * @param changes changes  
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["refresh"] && changes["refresh"].currentValue == true) {
			this.respondToRefresh();
		}
		if (changes["publicPanelData"]) {
			this.localPanelData = this.publicPanelData;
		}
		if (changes["isMobile"]) {
			if (this.isMobile) {
				this.rangeWidth = 5;
			} else {
				this.rangeWidth = 15;
			}
		}
	}

	/**
	 * destroyPanel
	 */
	destroyPanel() {
		this.finalise.next();
		this.finalise.complete();
		if (this.refreshInterval) {
			this.refreshInterval.unsubscribe();  // Clear the interval if it's set
			this.refreshInterval = null;  // Reset to null to prevent memory leaks
		}
	}

	/**
	 * ngOnDestroy
	 */
	ngOnDestroy(): void {
		console.log("Destroying");
		this.destroyPanel();
	}

	/**
	 * respondToRefresh
	 */
	respondToRefreshOLD() {
		if (this.gauge) {
			let parent: HTMLElement | null = this.gauge.element;
			let panel: HTMLElement | undefined = undefined;
			while (parent) {
				if (parent.classList.contains("panel-host")) {
					panel = parent;
					parent = null;
					break;
				} else {
					parent = parent.parentElement;
				}
			}
			if (panel) {
				const height: number = panel.offsetHeight ?? 0;
				const width: number = panel.offsetWidth ?? 0;

				const title: HTMLElement | null = <HTMLElement>panel.getElementsByClassName("text-panel-title")[0];

				this.gauge.height = `${(!title ? height : height - title.offsetHeight) * 0.8}px`;
				this.gauge.width = `${width}px`;

				if (!this.creating && this.publicPanelData) {
					let axis = this.gauge.axes[0];
					const panelData = this.publicPanelData[parseInt(panel.id ?? '')];
					if (panelData) {
						axis.maximum = panelData.max ? panelData.max : 10;
						axis.minimum = panelData.min ? panelData.min : 0;
						axis.majorTicks!.interval = panelData.interval;
					}
				}
				// this.gauge.refresh();
			}
		}
	}

	/**
	 * respondToRefresh
	 */
	respondToRefresh() {
		this.setMinMaxInterval();
		this.setGaugeRanges();
		if (this.gauges.length > 0) {
			this.gauges.forEach((gauge: CircularGaugeComponent) => gauge.refresh());
		}
	}

	/**
	 * setMinMaxInterval
	 * @returns 
	 */
	setMinMaxInterval() {
		if (!this.creating && this.publicPanelData) {
			const panelData = this.publicPanelData[parseInt(this.panelData.id ?? '')];
			if (panelData) {
				const ranges = this.panelData.ranges.filter((x: any) => x.max.length > 0 && x.min.length > 0);
				for (let i: number = 0; i < this.panelData.datapoints.length; i++) {
					// const min = Math.min(panelData.min!, ranges[0].min[i]);
					// const max = Math.max(panelData.max!, ranges[ranges.length - 1].max[i]);
					const min = ranges[0].min[i];
					const max = ranges[ranges.length - 1].max[i];
					this.axisConfig[i] = {
						min: min,
						max: max,
						interval: max - min
					};
					this.majorTicks[i] = {
						height: 0,
						width: 0,
						interval: max - min
					};
				}
			}
		}
	}

	/**
	 * setGaugeRanges
	 */
	setGaugeRanges() {
		if (!this.creating) {
			this.gaugeRanges = this.getGaugeRanges();
		}
	}

	/**
	 * getGaugeRange
	 * @returns 
	 */
	getGaugeRanges(): { start: number, end: number }[] {
		let result: { start: number, end: number }[] = [];
		const data = this.publicPanelData[this.panelData.id];
		if (data && data.max && data.min) {
			const max = data.max;
			const min = data.min;
			if (min != undefined && max != undefined) {
				result.push({
					start: 0,
					end: parseFloat((max * 0.3).toFixed(1))
				});
				result.push({
					start: parseFloat((max * 0.3).toFixed(1)),
					end: parseFloat((max * 0.7).toFixed(1))
				});
				result.push({
					start: parseFloat((max * 0.7).toFixed(1)),
					end: parseFloat((max).toFixed(1))
				});
			}
		} else {
			result = this.gaugeRanges;
		}
		return result;
	}

	/**
	 * resolveRangeColour
	 * @param value value 
	 * @param index index 
	 * @returns 
	 */
	resolveRangeColour(value: number, index: number): string {
		if (this.panelData.ranges && this.panelData.ranges[0].min[index] != undefined) {
			let result: string = "";
			let newBorderColour: string = "";
			let score: number = 0;
			let border: boolean = false;
			const rangeValues = this.panelData.ranges.map((x: any) => [x.min[index], x.max[index]]);
			if (value <= rangeValues[0][1]) {
				const range = this.panelData.ranges[0];
				result = range.color[index] || this.getDefaultRangeColour(range, index, 0);
				score = 1;
				border = range.createsBorder[index];
			} else if (value >= rangeValues[1][0] && value <= rangeValues[1][1]) {
				const range = this.panelData.ranges[1];
				result = range.color[index] || this.getDefaultRangeColour(range, index, 1);
				score = 2;
				border = range.createsBorder[index];
			} else if (value >= rangeValues[2][0]) {
				const range = this.panelData.ranges[2];
				result = range.color[index] || this.getDefaultRangeColour(range, index, 2);
				score = 3;
				border = range.createsBorder[index];
			}
			this.indexColours[index] = { colour: result, score: score, border: border };
			let currentHighest: number = 0;
			let currentHighestColour: string = "";
			let shouldCreateBorder: boolean = false;
			this.indexColours.forEach((colour: any) => {
				if (colour.score > currentHighest) {
					currentHighest = colour.score;
					currentHighestColour = colour.colour;
					shouldCreateBorder = colour.border;
				}
			});
			if (this.currentBorderColour != currentHighestColour) {
				this.currentBorderColour = currentHighestColour;
				if (shouldCreateBorder) {
					this.borderChange.emit(this.currentBorderColour);
				} else {
					this.borderChange.emit('');
				}
			}
			return result;
		} else {
			return "black";
		}
	}

	/**
	 * getDefaultRangeColour
	 * @param range range 
	 */
	getDefaultRangeColour(range: any, index: number, rangeIdx: number): string {
		let result: string = "";
		if (!range.name[index]) {
			result = this.defaultRangeColours[rangeIdx];
		} else if (["Low", "Normal", "High"].includes(range.name[index])) {
			switch (range.name[index]) {
				case "Low":
					result = this.defaultRangeColours[0];
					break;
				case "Normal":
					result = this.defaultRangeColours[1];
					break;
				case "High":
					result = this.defaultRangeColours[2];
					break;
			}
		}
		return result;
	}

	/**
	 * gaugeMouseOver
	 * @param event event  
	 */
	gaugeMouseOver(event: any) {
		const target = event.target;
		if (target.id.includes("Axis_0_Range")) {
			if (!target.id.includes("Axis_0_Range_0")) {
				const gauge = this.getGaugeElementFromHoveredElement(target);
				const gaugeIdx = parseInt(gauge.classList[1].slice(-1));
				const rangeIdx = parseInt(target.id.slice(-1)) - 1;
				const range = this.panelData.ranges[rangeIdx];
				const min = range.min[gaugeIdx];
				const max = range.max[gaugeIdx];
			}
		}
	}

	/**
	 * getGaugeElementFromHoveredElement
	 * @param target target 
	 * @returns 
	 */
	getGaugeElementFromHoveredElement(target: HTMLElement): HTMLElement {
		let result = target;
		let currentElement: HTMLElement = target;
		while (currentElement.parentElement) {
			if (currentElement.parentElement.classList.contains("_circ-gauge")) {
				result = currentElement.parentElement;
				break;
			} else {
				currentElement = currentElement.parentElement;
			}
		}
		return result;
	}

	/**
	 * tooltipRender
	 * @param event event 
	 */
	tooltipRender(event: any, gaugeIdx: number) {
		let eventRange = event.range;
		const range = this.panelData.ranges.find((x: any) => x.min[gaugeIdx] == eventRange.start && x.max[gaugeIdx] == eventRange.end);
		const rangeIdx = this.panelData.ranges.indexOf(range);
		const name = range.name[gaugeIdx] ?? ["Low", "Normal", "High"][rangeIdx];
		event.content = `Name: ${name} <br> Start: ${range.min[gaugeIdx]} <br> End: ${range.max[gaugeIdx]}`;

		// let rangeIdx = parseInt(eventRange.pathElement[0].id.slice(-1));
		// if (rangeIdx == 0) {
		// 	event.cancel = true;
		// } else {
		// 	rangeIdx -= 1;
		// 	const range = this.panelData.ranges[rangeIdx];
		// 	const name = range.name[gaugeIdx] ?? ["Low", "Normal", "High"][rangeIdx];
		// 	event.content = `Name: ${name} <br> Start: ${range.min[gaugeIdx]} <br> End: ${range.max[gaugeIdx]}`;
		// }
	}

	/**
	 * getAxisMaxMinForRanges
	 */
	getAxisMaxMinForRanges(index: number): { min: number, max: number, interval: number } {
		let min: number = Math.min(...this.panelData.ranges.map((x: any) => x.min[index]).filter((x: number) => x != null && x != undefined));
		let max: number = Math.max(...this.panelData.ranges.map((x: any) => x.max[index]).filter((x: number) => x != null && x != undefined));
		return { min: min, max: max, interval: max - min };
	}
}

CircularGaugeComponent.Inject(Legend);
CircularGaugeComponent.Inject(Gradient);
CircularGaugeComponent.Inject(GaugeTooltip);
